import createHistory from 'history/createBrowserHistory';
export default createHistory();

//https://github.com/ReactTraining/react-router/issues/4895
//https://github.com/ReactTraining/react-router/issues/4059